import Vue from 'vue'
import { countRemainingTimeForShipping, formatSliceYear } from '@/common/utils/common'
import { ProductEstimate, ProductState } from '@/product/types'

export default Vue.extend({
  data(): {
    calcTimeInterval: number | null
    timeLeft: string
  } {
    return {
      calcTimeInterval: null,
      timeLeft: ''
    }
  },
  computed: {
    $_storeSate(): ProductState {
      return this.$store.state
    },
    $_estimate(): ProductEstimate {
      return this.$_storeSate.estimate
    },
    $_showConvenienceStoreInfo(): boolean {
      return !this.$store.getters.isFastShippingSelected
    }
  },
  created() {
    this.calcTimeInterval = window.setInterval(() => {
      this.timeLeft = countRemainingTimeForShipping()
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.calcTimeInterval!)
  },
  methods: {
    formatSliceYear
  }
})
